"use client"

import { ImageUploadField } from "@/(admin)/modules/ui-builder/config/lib/ImageUploadField"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { CardProfile, RenderConfig } from "./RenderConfig"

export const CCACardProfile: ComponentConfig<CardProfile> = {
  label: "CaoCao | Card Profile",
  //@ts-ignore
  fields: {
    mailTo: {
      label: "Send to Email:",
      type: "text",
    },
    items: {
      min: 1,
      label: "Items",
      type: "array",
      getItemSummary: (item, index = 0) => `${index + 1}. ${item.name && item.name}`,
      arrayFields: {
        img: {
          label: "Image",
          type: "custom",
          render: props => <ImageUploadField {...props} />,
        },
        name: {
          label: "Name",
          type: "text",
        },
        position: {
          label: "Position",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    mailTo: "caocaoadventures@gmail.com",
    items: [
      {
        name: "Lorem ipsum",
        position: "Lorem ipsum",
        description: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit",
      },
    ],
    className: "flex items-center gap-2",
    styles: {
      mobile: {
        display: "flex",
      },
      tablet: {
        display: "flex",
      },
      desktop: {
        display: "flex",
      },
    },
  },
  ...RenderConfig,
}
export { RenderConfig }
